// Lib
import { oc } from "ts-optchain";

// Services
import { ObjectUtil } from "@/services";

// Types
import {
  CartOrderType,
  IOrderOptionsDto,
  IShoppingCartListResponseDto,
  PartValidationReason,
} from "@/types";
import {
  IShoppingCartContext,
} from "../Types";

export class CartService {

  public static getOrderType(context: IShoppingCartContext): CartOrderType {
    const items = context.cartData.Items;

    const mcfa = items.some((p) => !CartService.isRpiServiced(p));
    const rpi = items.some((p) => CartService.isRpiServiced(p));

    if (mcfa && rpi) {
      return CartOrderType.Both;
    }

    return mcfa ? CartOrderType.Mcfa : CartOrderType.RapidParts;
  }

  public static isRpiServiced(dto: any): boolean {
    return oc(dto as any).isRpiServiced(false);
  }

  public static canProceedToStep2(context: IShoppingCartContext, cartData: IShoppingCartListResponseDto) {
    return (
      cartData.Items.length > 0 &&
      cartData.Items.every((x) => x.PartValidation.IsValid === true || x.PartValidation.ValidationReason === PartValidationReason.IsValid)
    );
  }

  public static canProceedToStep3(context: IShoppingCartContext, cartData: IShoppingCartListResponseDto, offlineToSap: boolean, offlineToWarehouseSystems: boolean) {
    //Need to make sure there's no ordervalidation errors as well.
    var orderErrors = cartData.ValidationResults.ValidationErrors.length > 0
    
    // Reason 35 is type OfflineToSap but there is something funky with the export of OrderValidationErrorReason where it is set to a string instead of the 35enum
    if(cartData.ValidationResults.ValidationErrors.length === 1 && cartData.ValidationResults.ValidationErrors[0].Reason.toString() === '35') {
      orderErrors = false;
    }

    // Reason 37 is type OfflineToWarehouseSystems, refer to comment above
    if(cartData.ValidationResults.ValidationErrors.length === 1 && cartData.ValidationResults.ValidationErrors[0].Reason.toString() === '37') {
      orderErrors = false;
    } 

    return !orderErrors && CartService.canSubmitOrder(context, cartData, offlineToSap, offlineToWarehouseSystems);
  }

  public static canSubmitOrder(context: IShoppingCartContext, cartData: IShoppingCartListResponseDto, offlineToSap: boolean, offlineToWarehouseSystems: boolean) {
    // allow cart submission if SAP is offline
    if(offlineToSap || offlineToWarehouseSystems){
      return (
        cartData.Items.length > 0
      );
    }
    
    return (
      cartData.Items.length > 0 &&
      cartData.Items.every((x) => x.PartValidation.IsValid === true || x.PartValidation.ValidationReason === PartValidationReason.IsValid )
    );
  }

  public static getOrCreateOrderOptions(context: any): any {
    return (
      context.orderOptions ??
      ObjectUtil.createInstance<IOrderOptionsDto>({
        IgnorePoNumber:false,
        IsWarrantyClaim: false,
        WarrantyModel: "",
        WarrantySerial: "",
        IsShipToCustomer: false,
        CustomerAddressName: "",
        CustomerAddressName2: "",
        CustomerAddress1: "",
        CustomerAddress2: "",
        CustomerCity: "",
        CustomerStateProvince: "",
        CustomerPostalCode: "",
        CustomerCountryCode: "",
        ShouldSaveCustomerAddress: false,
        IsEmergencyShipTo: false,
        EmergencyAddressName: "",
        EmergencyAddress1: "",
        EmergencyAddress2: "",
        EmergencyCity: "",
        EmergencyStateProvince: "",
        EmergencyPostalCode: "",
        EmergencyCountryCode: "",
        IsFinalToCustomer: false,
        FinalToCustomerAddressName: "",
        FinalToCustomerAddress1: "",
        FinalToCustomerAddress2: "",
        FinalToCustomerCity: "",
        FinalToCustomerStateProvince: "",
        FinalToCustomerPostalCode: "",
        FinalToCustomerCountryCode: "",
        FinalToShouldSaveCustomerAddress: false,
        AlternateWarehouses: [],
        DropShipOverrides: [],
        Other3pShippingAccounts: [],
        SapFreightTerm: "",
      })
    );
  }
}
